import { strapi } from './strapi'
import anime from 'animejs';

export let infoBar = {
    rowHeight: 90,
    initialYOffset: 0,
    rowsYOffset: 0,
    rows: [
        "One morning, when **Gregor Samsa** woke from troubled dreams, he found",
        "himself transformed in his bed into a **horrible vermin**. He lay on his",
        "armour-like back, and if he lifted his head a little he could see",
        "his brown belly, slightly **domed** and **divided** by arches into stiff sections.",
    ],
    currentRows: [],
    rowsEl: undefined,
    totalSteps: 0,
    advanceTimeout: 7000,
    advanceInterval: -1,
    currentInforollNumber: 0,

    initVariables: () => {
        infoBar.initialYOffset = -infoBar.rowHeight;
        infoBar.rowsYOffset = infoBar.initialYOffset;
        infoBar.rowsEl = document.getElementById("infobar-rows");
        infoBar.totalSteps = infoBar.rowsEl.children.length + 2;
    },

    createDomElements: () => {
        let rowParent = document.getElementById("infobar-rows");
        rowParent.innerHTML = "";

        infoBar.rows = infoBar.getRows();
        infoBar.advanceTimeout = infoBar.getAdvanceTimeout();
        
        infoBar.currentRows = infoBar.rows[infoBar.currentInforollNumber];
        infoBar.currentRows?.forEach(row => {
            var rowNode = document.createElement("div");
            rowNode.className = 'infobar-row bar-height';
            const rowText = row.replaceAll(/[*][*](.*?)[*][*]/g, '<span class="hl">$1</span>');
            rowNode.innerHTML = rowText;
            rowParent.appendChild(rowNode);
        });
    },

    getRows: () => {
        infoBar.rows = strapi.getInforollRows()?.split("\n\n").map(inforoll => inforoll.split("\n"));
        return infoBar.rows;
    },

    getAdvanceTimeout: () => {
        return strapi.getInforollAdvanceTimeout();
    },

    start: () => {
        infoBar.createDomElements();
        infoBar.initVariables();
        infoBar.advanceInterval = setInterval(infoBar.advanceNextRow, infoBar.advanceTimeout);
        infoBar.advanceNextRow();
    },

    advanceNextRow: () => {
        anime({
            targets: infoBar.rowsEl,
            translateY: infoBar.rowsYOffset,
            easing: 'easeInOutQuad',
            duration: 250,
        });
        infoBar.rowsYOffset -= infoBar.rowHeight;

        if (infoBar.rowsYOffset <= -infoBar.rowHeight * (infoBar.totalSteps)) {
            infoBar.currentInforollNumber++;
            if (infoBar.currentInforollNumber >= infoBar.rows.length) {
                infoBar.currentInforollNumber = 0;
            }
            // console.log("Advancing inforoll", infoBar.currentInforollNumber);
            setTimeout(infoBar.clearIntervalAndReset, 500);
        }
    },

    clearIntervalAndReset: () => {
        clearInterval(infoBar.advanceInterval);
        anime({
            targets: infoBar.rowsEl,
            translateY: 0,
            easing: 'steps(1)',
            complete: () => {
                infoBar.start();
            },
        });
    }
}

window.infoBar = infoBar;

strapi.callWhenReady(infoBar.start);

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const debug = urlParams.get('debug') === 'true' || false;


if (debug)
    document.getElementById("infobar").classList.add("debug");
else    
    document.getElementById("infobar").classList.remove("debug");
